const PAYMENT_METHODS = {
  CASH: 'paymentMethodCash',
  CREDIT_CARD: 'paymentMethodCreditCard',
};

export default PAYMENT_METHODS;
